export default __webpack_public_path__ + "static/media/clima.9ff9d8ce.png";